import React from "react";
import ConnectionFormDialog from "../../../components/forms/ConnectionFormDialog";
import FormSelectField from "../../../components/forms/fields/basic/SelectField";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import { ConnectionFormDataController } from "../../../controllers/formController";
import {
  ReferenceVersionConnection,
  VersionReferenceTypes,
} from "../../../types/referenceVersion";
import renderPersonSelection from "../../../components/entitiesReferences/SelectionModals/PersonSelectionModal";
import renderVersionSelection from "../../../components/entitiesReferences/SelectionModals/VersionSelectionModal";
import { Version } from "../../../types/version";
import { Person } from "../../../types/person";
import { EntitySelectionProps } from "../../entitiesReferences/EntitySelectionInput";

interface ReferenceVersionProps {
  controller: ConnectionFormDataController<
    ReferenceVersionConnection,
    Version,
    Version | Person
  >;
  systemLanguageType: Version["system_language_type"];
}

const TO_LABELS: Record<string, string> = {
  person: "Person",
  version: "Version",
};

const TO_COLLECTIONS: Record<string, SystemEntityCollections> = {
  person: SystemEntityCollections.PERSON,
  version: SystemEntityCollections.VERSION,
};

const ReferenceVersionDialog: React.FC<ReferenceVersionProps> = ({
  controller,
  systemLanguageType,
}) => {
  const toEntity =
    controller.defaultValues.system_reference_to_entity ?? "version";
  const renderToSelection =
    toEntity === "person"
      ? renderPersonSelection
      : renderVersionSelection(systemLanguageType);
  const renderToEntitySelection = renderToSelection as (
    props: EntitySelectionProps<Version | Person>
  ) => React.ReactElement;

  return (
    <ConnectionFormDialog<ReferenceVersionConnection, Version, Version | Person>
      controller={controller}
      fromLabel="Version"
      fromEntityCollection={SystemEntityCollections.VERSION}
      toLabel={TO_LABELS[toEntity]}
      toEntityCollection={TO_COLLECTIONS[toEntity]}
      renderFromEntitySelection={renderVersionSelection(systemLanguageType)}
      renderToEntitySelection={renderToEntitySelection}
    >
      <FormSelectField
        name="version_reference_type"
        label="Reference Type"
        placeholder="Select reference type"
        options={Object.values(VersionReferenceTypes).map((item) => ({
          value: item,
          label: item,
        }))}
        required
      />
    </ConnectionFormDialog>
  );
};

export default ReferenceVersionDialog;
